import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 11\" id=\"plus\">\r\n<style type=\"text/css\">\r\n\t#plus .st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n</style>\r\n<polygon class=\"st0\" points=\"12,4.1 7.7,4.1 7.7,0 4.4,0 4.4,4.1 0,4.1 0,7 4.4,7 4.4,11 7.7,11 7.7,7 12,7 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol